import { atom, selector } from 'recoil';
import { Subscription, SubscriptionPackage } from '@givz/core-client';
import { DropdownOption } from 'src/types';

export const pendingSubscriptionState = atom<Subscription | undefined>({
  default: undefined,
  key: 'pendingSubscriptionState',
});

export const subscriptionState = atom<Subscription | undefined>({
  default: undefined,
  key: 'subscriptionState',
});

export const subscriptionsPackagesState = atom<SubscriptionPackage[]>({
  default: [],
  key: 'subscriptionsPackagesState',
});

export const subscriptionPackagesDropdownOptionsState = selector<
  DropdownOption[]
>({
  get: ({ get }) => {
    const subscription = get(subscriptionState);
    const subscriptionsPackages = get(subscriptionsPackagesState);

    return [
      {
        id: 'changeSubscription',
        label: 'Change Subscription',
        name: 'changeSubscription',
      },
    ].concat(
      subscriptionsPackages
        .filter(
          (subscriptionPackage) =>
            !subscription ||
            subscription.packageKey !== subscriptionPackage.key,
        )
        .map((subscriptionsPackage) => {
          return {
            id: subscriptionsPackage.key,
            label: subscriptionsPackage.name,
            name: subscriptionsPackage.key,
          };
        }),
    );
  },
  key: 'subscriptionPackagesDropdownOptionsState',
});
